import React, {useEffect, useState} from 'react';
import {useLazyQuery} from '@apollo/client';
import {query} from '../../../services/queries/queries';
import SubtacticsRender from './Subtactics.render';
import SubtacticForm from '../forms/SubtacticForm';

export default function SubtacticsLoad(){

	const [loading, setLoading] = useState<boolean>(true);
	const [form, setForm] = useState(false);
	const [tId, setTId] = useState<string>("");

	const [queryTactics, { data }] = useLazyQuery(query("subtacticFindMany"));

	useEffect(()=>{
		if(loading){
			queryTactics({
				//variables: {},
				fetchPolicy: 'no-cache',
				onCompleted: (data:any):void => setLoading(false)
			});
		}
	},[loading]);

	return (
		<div>
			{loading ?
				<div>
					Loading tactics...
				</div>
				:
				<SubtacticsRender tactics={data?.subtacticFindMany || []} setTId={setTId} setLoading={setLoading} tId={tId} setForm={setForm} />
			}

			{form &&
				<div className="fixed right-0 top-2 neutral-800 b-neutral-700-t-l br-tl p-2 bottom-0 flex form-enter overflow-y-scroll">
					<div className="grows">
						<SubtacticForm setForm={setForm} setLoading={setLoading} tId={tId} setTId={setTId} />
					</div>
				</div>
			}

		</div>
	)
}
